export default "__VITE_ASSET__fbe69353__"